import { useFxWorkspaceContext } from '@mobile-mapping/providers';
import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { PanelLayoutWithHeaderToggle } from '@trimble/ui-components/solidjs';
import { Component, createMemo, Show } from 'solid-js';
import { Dynamic } from 'solid-js/web';

import { ExtractionSourceList } from './extraction-workflow/ExtractionSourceList';
import { ExtractionWorkflowSubtitle } from './extraction-workflow/ExtractionWorkflowSubtitle';
import { getExtractionWorkflowSettingsComponent } from './extraction-workflow/extraction-workflow-settings.registry';

export interface ExtractionWorkflowPanelProps {
  onClose(): void;
}

export const ExtractionWorkflowPanel: Component<
  ExtractionWorkflowPanelProps
> = (props) => {
  const fxWorkspace = useFxWorkspaceContext();

  const settingsComponent = createMemo(() =>
    getExtractionWorkflowSettingsComponent(
      fxWorkspace.selectedExtractionWorkflow()
    )
  );

  return (
    <PanelLayoutWithHeaderToggle
      panelTitle={t('mobileMapping.fxWorkspace.extraction.parametersTitle')}
      titleDataCy="extraction-workflow-panel-title"
      rightActions={
        <IconButton
          color={BtnClasses.TERTIARY}
          icon="tc-icon-content-close"
          size="icon-medium"
          data-cy="extraction-workflow-panel-close"
          clicked={props.onClose}
        />
      }
      content={
        <div class="flex flex-col gap-4 p-[1rem]">
          <ExtractionWorkflowSubtitle />
          <Show keyed when={fxWorkspace.activeWorkspaceId()}>
            {(activeWorkspaceId) => (
              <ExtractionSourceList activeWorkspaceId={activeWorkspaceId} />
            )}
          </Show>
          <Dynamic component={settingsComponent()} />
        </div>
      }
    />
  );
};
